import React, { Component } from 'react';
import { AbstractIcon } from './AbstractIcon';
import { AbstractIconDefaultProps, AbstractIconPropTypes } from './utils';

export class QuestionMarkIcon extends Component {
    static defaultProps = AbstractIconDefaultProps;
    static propTypes = AbstractIconPropTypes;

    render() {
        const props = this.props;

        return (
            <AbstractIcon viewBox="0 0 13 12" {...props}>
                <path
                    // eslint-disable-next-line max-len
                    d="M5.61841 9.49999H6.78507V8.33332H5.61841V9.49999ZM6.20174 0.166656C2.98174 0.166656 0.368408 2.77999 0.368408 5.99999C0.368408 9.21999 2.98174 11.8333 6.20174 11.8333C9.42174 11.8333 12.0351 9.21999 12.0351 5.99999C12.0351 2.77999 9.42174 0.166656 6.20174 0.166656ZM6.20174 10.6667C3.62924 10.6667 1.53507 8.57249 1.53507 5.99999C1.53507 3.42749 3.62924 1.33332 6.20174 1.33332C8.77424 1.33332 10.8684 3.42749 10.8684 5.99999C10.8684 8.57249 8.77424 10.6667 6.20174 10.6667ZM6.20174 2.49999C4.91257 2.49999 3.86841 3.54416 3.86841 4.83332H5.03507C5.03507 4.19166 5.56007 3.66666 6.20174 3.66666C6.84341 3.66666 7.36841 4.19166 7.36841 4.83332C7.36841 5.99999 5.61841 5.85416 5.61841 7.74999H6.78507C6.78507 6.43749 8.53507 6.29166 8.53507 4.83332C8.53507 3.54416 7.49091 2.49999 6.20174 2.49999Z"
                    fill="currentColor" />
            </AbstractIcon>
        );
    }
}
